import m from "./../../../dist/es2015/locales/pt_BR.js";
export const am5locales_pt_BR = m;